
import vClickOutside from 'v-click-outside'

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    guests: {
      type: Number,
      default: 2
    },
    rooms: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      isOpen: false,
      localRooms: [],
      nextRoomId: 0
    }
  },
  computed: {
    siteType () {
      return this.$store.state.siteType
    },
    totalGuests () {
      return this.localRooms.reduce((sum, r) => sum + r.adults + r.children.length, 0)
    },
    guestsSummary () {
      const total = this.totalGuests
      const roomCount = this.localRooms.length
      const { siteType } = this
      const guestLabel = total === 1
        ? this.$t(`${siteType}.search.guest`)
        : this.$t(`${siteType}.search.guests`)
      const roomLabel = roomCount === 1
        ? this.$t(`${siteType}.search.room`)
        : this.$t(`${siteType}.search.rooms`)
      return `${total} ${guestLabel} · ${roomCount} ${roomLabel}`
    }
  },
  created () {
    this.initRooms()
  },
  methods: {
    initRooms () {
      const count = Math.max(1, this.rooms)
      this.localRooms = Array.from({ length: count }, (_, i) => ({
        id: this.nextRoomId++,
        adults: i === 0 ? Math.max(1, this.guests) : 2,
        children: []
      }))
    },
    toggle () {
      this.isOpen = !this.isOpen
    },
    close () {
      this.isOpen = false
    },
    changeAdults (ri, delta) {
      const room = this.localRooms[ri]
      room.adults = Math.min(6, Math.max(1, room.adults + delta))
    },
    addChild (ri) {
      if (this.localRooms[ri].children.length < 4) {
        this.localRooms[ri].children.push('<1')
      }
    },
    removeChild (ri) {
      this.localRooms[ri].children.pop()
    },
    setChildAge (ri, ci, value) {
      this.localRooms[ri].children.splice(ci, 1, value)
    },
    addRoom () {
      if (this.localRooms.length < 6) {
        this.localRooms.push({ id: this.nextRoomId++, adults: 2, children: [] })
      }
    },
    removeRoom (ri) {
      this.localRooms.splice(ri, 1)
    },
    save () {
      this.$emit('update', {
        numOfGuests: this.totalGuests,
        numOfRooms: this.localRooms.length
      })
      this.close()
    }
  }
}
